<template>
  <div class="flash-block">
    <div v-if="title" class="flash-block-title">{{ title }}</div>
    <div class="flash-block__content">
      <div v-if="$slots.header" class="flash-block_header">
        <slot name="header" />
      </div>
      <div class="flash-block_body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Block',

  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.flash-block__content {
  background-color: #fff;
  border-radius: 32px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

  .flash-block_header {
    padding: 52px 46px;
  }

  .flash-block_body {
    padding: 0 36px;
  }
}

.flash-block-title {
  margin-bottom: 32px;
  font-size: 24px;
  color: #7f7f7f;
}
</style>
